import http from "@seims/shared/src/services/HttpService";

const endpoint = `/lookup/citizen/science/`;

const getScienceFields = async () => {
    const response = await http.get(`${endpoint}fields`);
    return response;
}

const getScienceDomains = async () => {
    const response = await http.get(`${endpoint}domains`);
    return response;
}

const getScienceDomainsByFields = async (id) => {
    const response = await http.get(`${endpoint}domains/${id}`);
    return response;
}

const getScienceMethodologies = async () => {
    const response = await http.get(`${endpoint}methodologies`);
    return response;
}
const getObjectives = async () => {
    const response = await http.get(`${endpoint}objectives`);
    return response;
}
const getDisseminationApproaches = async () => {
    const response = await http.get(`${endpoint}disseminations`);
    return response;
}

const getBeneficiaries = async () => {
    const response = await http.get(`${endpoint}beneficiary-impacts`);
    return response;
}

const getParticipantRoles = async (roleType) => {
    const response = await http.get(`${endpoint}participant-roles?stage=${roleType}`);
    return response;
}

const getContributionRecognitions = async () => {
    const response = await http.get(`${endpoint}contribution-recognitions`);
    return response;
}

const getParticipantStatuses = async () => {
    const response = await http.get(`${endpoint}participant-status`);
    return response;
}


// eslint-disable-next-line import/no-anonymous-default-export
export default {
    getObjectives,
    getScienceFields,
    getScienceDomains,
    getScienceMethodologies,
    getBeneficiaries,
    getParticipantRoles,
    getContributionRecognitions,
    getScienceDomainsByFields,
    getDisseminationApproaches,
    getParticipantStatuses
}
